<template>
  <form class="space-y-6" @submit.prevent="onSubmit">
    <FormField v-slot="{ componentField }" name="email">
      <FormItem>
        <FormLabel class="font-medium text-sm">Email</FormLabel>
        <FormControl>
          <Input type="email" placeholder="Enter your email" v-bind="componentField" class="border" />
        </FormControl>
        <FormMessage />
      </FormItem>
    </FormField>

    <FormField v-slot="{ componentField }" name="password">
      <FormItem>
        <FormLabel class="font-medium text-sm">Password</FormLabel>
        <FormControl>
          <div class="relative">
            <Input
              v-bind="componentField"
              :type="showPassword ? 'text' : 'password'"
              placeholder="Enter your password"
              maxlength="100"
              class="border pr-10"
            />
            <FormPasswordEye :password-shown="showPassword" @click="showPassword = !showPassword" />
          </div>
        </FormControl>
        <FormMessage />
      </FormItem>
    </FormField>

    <p class="text-xs text-muted-foreground">
      <NuxtLink to="/forgot-password" class="underline">Forgot your password?</NuxtLink>
    </p>

    <Button type="submit" class="w-full" :disabled="isSubmitting">Sign In</Button>
  </form>
</template>

<script setup lang="ts">
import { useForm } from 'vee-validate'
import { toTypedSchema } from '@vee-validate/zod'
import * as z from 'zod'
import ZodMessages from '@@/zod_presets/messages'
import FormPasswordEye from '@/components/ui/form/FormPasswordEye.vue'

const emit = defineEmits(['submit'])

const showPassword = ref(false)

const formSchema = toTypedSchema(
  z.object({
    email: z.string().email(ZodMessages.email),
    password: z.string().min(1, 'Password is required'),
  }),
)

const { handleSubmit, isSubmitting } = useForm({
  validationSchema: formSchema,
})

const onSubmit = handleSubmit(values => emit('submit', values))
</script>
